import type { GetConversation200AllOfThreeMessagesItem } from './getConversation200AllOfThreeMessagesItem';

export type GetConversation200AllOfThree = {
  /** 대화 전체 메시지 목록 */
  messages?: GetConversation200AllOfThreeMessagesItem[];
};
